import { render, staticRenderFns } from "./OrdenDeSalida.vue?vue&type=template&id=37c31392&scoped=true&"
import script from "./OrdenDeSalida.vue?vue&type=script&lang=js&"
export * from "./OrdenDeSalida.vue?vue&type=script&lang=js&"
import style0 from "./OrdenDeSalida.vue?vue&type=style&index=0&id=37c31392&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c31392",
  null
  
)

export default component.exports